import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { InvoiceSurveysApi } from '../api/invoice-surveys.api';
import { GetSurveysFilters, Survey } from '../models/invoice-survey.model';

@Injectable({ providedIn: 'root' })
export class InvoiceSurveysService {
  private readonly _api = inject(InvoiceSurveysApi);

  public get(filters: GetSurveysFilters, page: number): Observable<Survey[]> {
    return this._api.get(filters, page);
  }
}
